// extracted by mini-css-extract-plugin
export default {"metadataSection":"PromotionTypeForm__metadataSection-S0zq2"};